import $ from "jquery";
import { track } from "lib/analytics";

const toggleSidebar = () => {
  const openButton = $("#small-sidebar-open-button");
  const closeButton = $("#small-sidebar-close-button");
  const sidebar = $("#small-sidebar");
  const wrapper = $("#page-wrapper");

  if (sidebar.hasClass("visible")) {
    openButton.removeClass("visible");
    closeButton.removeClass("visible");
    sidebar.removeClass("visible");
    wrapper.removeClass("overlay-visible");

    track("Mobile navigation", "Close");
  } else {
    openButton.addClass("visible");
    closeButton.addClass("visible");
    sidebar.addClass("visible");
    wrapper.addClass("overlay-visible");

    track("Mobile navigation", "Open");
  }
};

export default async () => {
  $("#small-region-select-dropdown").on("change", (event) => {
    track("Mobile navigation - Edition", "Click", event.target.value);
    window.location = event.target.value;
  });

  $("#small-sidebar-open-button").on("click", toggleSidebar);
  $("#small-sidebar-close-button").on("click", toggleSidebar);
};
